export const VARIENT = {
  contained: 'contained',
  cancel: 'cancel',
  outlined: 'outlined',
  noOutlinedButtonStyle: 'noOutlinedButtonStyle',
};
